import { DropdownOptionResponse } from '@/@types/responses/common/DropdownOptionResponse'
import { DropdownOptionsResponse } from '@/@types/responses/common/DropdownOptionsResponse'
import { CartridgeMessage } from '@/@types/messages/CartridgeMessage'
import { AppConfig } from '@/app.config'
import authenticatedFetch from '@/authenticatedFetch'
import { MiscellaneousService } from './miscellaneous.service'

export class CartridgeService {
  private appConfig: AppConfig
  private miscellaneousService: MiscellaneousService

  constructor(miscellaneousService: MiscellaneousService) {
    this.appConfig = new AppConfig()
    this.miscellaneousService = miscellaneousService
  }

  public deleteCartridge(id: number): Promise<void> {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/cartridges/${id}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }

  public getCartridgeDropdownOptions(): Promise<DropdownOptionsResponse<DropdownOptionResponse<number>>> {
    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/cartridges/dropdown-options`, this.miscellaneousService).then(async response => {
      const json = await response.json()
      return json as DropdownOptionsResponse<DropdownOptionResponse<number>>
    })
  }

  public updateCartridge(cartridgeId: number, cartridgeMessage: CartridgeMessage): Promise<void> {
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cartridgeMessage)
    }

    return authenticatedFetch(`${this.appConfig.sacServicesUrl}/v1/cartridges/${cartridgeId}`, this.miscellaneousService, requestOptions).then(() => {
      return Promise.resolve()
    })
  }
}
